import DOMPurify from "dompurify";

const sanitizeInput = (data) => {
  const options = { ALLOWED_TAGS: [], ALLOWED_ATTR: [] };

  return DOMPurify.sanitize(data, options);
};

export default sanitizeInput;